<div *ngIf="isMobile; else webLogin" class="full-container">
  <app-auth-header></app-auth-header>
  <div class="create-account-container">
    <div class="container-elements">
      <div class="mobile-header">
        <div class="mobile-title">Create Your Account, Enter the Details</div>
      </div>
      <div class="form-container-mobile" [ngClass]="{'prosumer-class': isProsumer()}">
        <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
          <div class="registration-form-box">
            <div class="form-group-mobile">
              <div class="form-field-mobile">
                <label for="firstName">First Name</label>
                <input id="firstName" type="text" formControlName="name" appInputRestriction="alphabetic"/>
                <div *ngIf="name?.invalid && (name?.dirty || name?.touched)">
                  <div class="error" *ngIf="name?.errors?.['required']">First Name is required.</div>
                </div>
              </div>
              <div class="form-field-mobile">
                <label for="lastName">Last Name</label>
                <input id="lastName" type="text" formControlName="last_name" appInputRestriction="alphabetic"/>
                <div *ngIf="last_name?.invalid && (last_name?.dirty || last_name?.touched)">
                  <div class="error" *ngIf="last_name?.errors?.['required']">
                    Last Name is required.
                  </div>
                  <div class="error" *ngIf="last_name?.errors?.['pattern']">Last Name should only contain letters, spaces, and apostrophes</div>
                </div>
              </div>
            </div>

            <div class="form-group-mobile">
              <div class="form-field-mobile">
                <label for="customer_category">Select Customer Category</label>
                <select id="customer_category" formControlName="customer_category" (change)="onCustomerCategoryChange($event)">
                  <option *ngFor="let user of customerCategories" [value]="user">{{ user}}</option>
                </select>
                <div *ngIf="customer_category?.invalid && (customer_category?.dirty || customer_category?.touched)">
                  <div class="error" *ngIf="customer_category?.errors?.['required']">
                    Customer Category is required.
                  </div>
                </div>
              </div>
              <div class="form-field-mobile">
                <label for="phone_number">Phone number</label>
                <input id="phone_number" type="text" formControlName="phone_number" readonly />
              </div>
            </div>

            <div class="form-group-mobile">
              <div class="form-field-mobile">
                <label for="state">Select State</label>
                <select id="state" formControlName="state_id">
                  <option *ngFor="let state of states" [value]="state.id">{{ state.name }}</option>
                </select>
                <div *ngIf="state?.invalid && (state?.dirty || state?.touched)">
                  <div class="error" *ngIf="state?.errors?.['required']">
                    State is required.
                  </div>
                </div>
              </div>
              <div class="form-field-mobile">
                <label for="utility">Select Utility / DISCOM</label>
                <select id="utility" formControlName="utility_id">
                  <option *ngFor="let utility of utilities" [value]="utility.id">{{ utility.name }}</option>
                </select>
                <div class="error" *ngIf="utility_id?.invalid && (utility_id?.dirty || utility_id?.touched)">
                  <div *ngIf="utility_id?.errors?.['required']">
                    Utility Name is required.
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group-mobile">
              <div class="form-field-mobile">
                <label for="locality">Enter Locality / Area Name</label>
                <input id="locality" type="text" formControlName="locality" appInputRestriction="alphanumeric"/>
                <div *ngIf="locality?.invalid && (locality?.dirty || locality?.touched)">
                  <div class="error" *ngIf="locality?.errors?.['required']">
                    Locality is required.
                  </div>
                </div>
              </div>
              <div class="form-field-mobile">
                <label for="pin_code">Enter PIN code</label>
                <input id="pin_code" type="text" formControlName="pin_code" appPinCode (blur)="validatePinCode()"/>
                <div *ngIf="pin_code?.invalid && (pin_code?.dirty || pin_code?.touched)">
                  <div class="error" *ngIf="pin_code?.errors?.['required']">PIN Code is required.</div>
                  <div class="error" *ngIf="pin_code?.errors?.['incorrectLength']">PIN Code should be exactly 6 digits.</div>
                </div>
              </div>
            </div>

            <div class="form-group-mobile">
              <div class="form-field-mobile">
                <label for="meter_number">Meter Number</label>
                <input id="meter_number" type="text" formControlName="meter_number" appInputRestriction="alphanumeric"/>
                <div class="error" *ngIf="meterNumber?.invalid && (meterNumber?.dirty || meterNumber?.touched)">
                  <div class="error" *ngIf="meterNumber?.errors?.['required']">
                    Meter number is required.
                  </div>
                </div>
              </div>
              <div class="form-field-mobile">
                <label for="connection_number">Connection Number</label>
                <input id="connection_number" type="text" formControlName="connection_number" appInputRestriction="alphanumeric"/>
                <div *ngIf="connection_number?.invalid && (connection_number?.dirty || connection_number?.touched)">
                  <div class="error" *ngIf="connection_number?.errors?.['required']">
                    Connection number is required.
                  </div>
                </div>
              </div>
            </div>
    
            <div class="form-group-mobile">
              <div class="form-field-mobile" *ngIf="isProsumer()">
                <label for="metering_category">Select Metering Category</label>
                <select id="metering_category" formControlName="metering_category">
                  <option *ngFor="let metering of meteringCategories" [value]="metering">{{ metering}}</option>
                </select>
                <div *ngIf="metering_category?.invalid && (metering_category?.dirty || metering_category?.touched)">
                  <div class="error" *ngIf="metering_category?.errors?.['required']">
                    Metering Category is required.
                  </div>
                </div>
              </div>
              <div class="form-field-mobile" *ngIf="isProsumer()">
                <label for="solar_capacity">Solar Capacity (kW)</label>
                <input id="solar_capacity" type="text" formControlName="solar_capacity" appOnlyNumber step="0.01" min="0.01"/>
                <div *ngIf="solar_capacity?.invalid && (solar_capacity?.dirty || solar_capacity?.touched)">
                  <div class="error" *ngIf="solar_capacity?.errors?.['required']">
                    Solar capacity is required.
                  </div>
                  <div class="error" *ngIf="solar_capacity?.errors?.['notPositive']">
                    Solar capacity must be greater than 0.
                  </div>
                </div>
              </div>
            </div>
          </div> 
        </form>
      </div>
      <div class="bottom-content">
        <!-- <div class="cancel-and-submit-buttons"> -->
          <!-- <div class="cancel-button-mobile">
            <button type="button" (click)="onCancel()">Cancel</button>
          </div> -->
          <div class="submit-button-mobile submit-registration">
            <button type="button" [disabled]="!registrationForm.valid" (click)="registrationForm.valid && onSubmit()">SUBMIT</button>
          </div>          
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>


<ng-template #webLogin>
  <div class="header">
    <img (click)="navigateTo('welcome')" class="img logo" src="assets/logo_transparent.png" />
    <div class="title">Peer to Peer Solar Energy Trading, Registration</div>
    <app-profile></app-profile>
  </div>
  <div class="registration-container">
    <div class="form-container">
      <div class="form-header">Please enter the Details for Registration</div>
      <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <div class="form-field">
            <label for="firstName">First Name</label>
            <input id="firstName" type="text" formControlName="name" appInputRestriction="alphabetic" />
            <div *ngIf="name?.invalid && (name?.dirty || name?.touched)">
              <div class="error" *ngIf="name?.errors?.['required']">First Name is required.</div>
            </div>
          </div>
          <div class="form-field">
            <label for="lastName">Last Name</label>
            <input id="lastName" type="text" formControlName="last_name" appInputRestriction="alphabetic" />
            <div *ngIf="last_name?.invalid && (last_name?.dirty || last_name?.touched)">
              <div class="error" *ngIf="last_name?.errors?.['required']">
                Last Name is required.
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="form-field">
            <label for="customer_category">Select Customer Category</label>
            <select id="customer_category"  formControlName="customer_category"
              (change)="onCustomerCategoryChange($event)">
              <option class="custom-select" *ngFor="let user of customerCategories" [value]="user">{{ user}}</option>
            </select>
            <div *ngIf="customer_category?.invalid && (customer_category?.dirty || customer_category?.touched)">
              <div class="error" *ngIf="customer_category?.errors?.['required']">
                Customer Category is required.
              </div>
            </div>
          </div>

          <div class="form-field">
            <label for="phone_number">Phone number</label>
            <input id="phone_number" type="text" formControlName="phone_number" readonly />
          </div>


        </div>
        <div class="form-group">

          <div class="form-field">
            <label for="state">Select State</label>
            <select id="state" formControlName="state_id">
              <option *ngFor="let state of states" [value]="state.id">{{ state.name }}</option>
            </select>
            <div *ngIf="state?.invalid && (state?.dirty || state?.touched)">
              <div class="error" *ngIf="state?.errors?.['required']">
                State is required.
              </div>
            </div>
          </div>

          <div class="form-field">
            <label for="utility">Select Utility / DISCOM</label>
            <select id="utility" formControlName="utility_id">
              <option *ngFor="let utility of utilities" [value]="utility.id">{{ utility.name }}</option>
            </select>
            <div class="error" *ngIf="utility_id?.invalid && (utility_id?.dirty || utility_id?.touched)">
              <div *ngIf="utility_id?.errors?.['required']">
                Utility Name is required.
              </div>
            </div>
          </div>

        </div>
        <div class="form-group">
          <div class="form-field">
            <label for="locality">Enter Locality / Area Name</label>
            <input id="locality" type="text" formControlName="locality" appInputRestriction="alphanumeric"/>
            <div *ngIf="locality?.invalid && (locality?.dirty || locality?.touched)">
              <div class="error" *ngIf="locality?.errors?.['required']">
                Locality is required.
              </div>
            </div>
          </div>
          <div class="form-field">
            <label for="pin_code">Enter PIN code</label>
            <input id="pin_code" type="text" formControlName="pin_code" appPinCode (blur)="validatePinCode()"/>
            <div *ngIf="pin_code?.invalid && (pin_code?.dirty || pin_code?.touched)">
              <div class="error" *ngIf="pin_code?.errors?.['required']">PIN Code is required.</div>
              <div class="error" *ngIf="pin_code?.errors?.['incorrectLength']">PIN Code should be exactly 6 digits.</div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="form-field">
            <label for="meter_number">Meter Number</label>
            <input id="meter_number" type="text" formControlName="meter_number" appInputRestriction="alphanumeric"/>
            <div class="error" *ngIf="meterNumber?.invalid && (meterNumber?.dirty || meterNumber?.touched)">
              <div class="error" *ngIf="meterNumber?.errors?.['required']">
                Meter number is required.
              </div>
              <div class="error" *ngIf="meterNumber?.errors?.['pattern']">Meter number should contain only numbers</div>

            </div>
          </div>

          <div class="form-field">
            <label for="connection_number">Connection Number</label>
            <input id="connection_number" type="text" formControlName="connection_number" appInputRestriction="alphanumeric"/>
            <div *ngIf="connection_number?.invalid && (connection_number?.dirty || connection_number?.touched)">
              <div class="error" *ngIf="connection_number?.errors?.['required']">
                Connection number is required.
              </div>
              <div class="error" *ngIf="connection_number?.errors?.['pattern']">Connection number should contain only numbers</div>

            </div>
          </div>
        </div>
        <div class="form-group">
          <div *ngIf="isProsumer()" class="form-field">
            <label for="metering_category">Select Metering Category</label>
            <select id="metering_category" formControlName="metering_category">
              <option *ngFor="let metering of meteringCategories" [value]="metering">{{ metering}}</option>
            </select>
            <div *ngIf="metering_category?.invalid && (metering_category?.dirty || metering_category?.touched)">
              <div class="error" *ngIf="metering_category?.errors?.['required']">
                Metering Category is required.
              </div>
            </div>
          </div>
          <div class="form-field" *ngIf="isProsumer()">
            <label for="solar_capacity">Solar Capacity (kW)</label>
            <input id="solar_capacity" min="0.1" type="text" appOnlyNumber formControlName="solar_capacity" step="0.01" min="0.01"/>
            <div *ngIf="solar_capacity?.invalid && (solar_capacity?.dirty || solar_capacity?.touched)">
              <div class="error" *ngIf="solar_capacity?.errors?.['required']">
                Solar capacity is required.
              </div>
              <div class="error" *ngIf="solar_capacity?.errors?.['notPositive']">
                Solar capacity must be greater than 0.
              </div>
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button type="button" (click)="onCancel()">Cancel</button>
          <button type="submit" [disabled]="!registrationForm.valid"
            [ngClass]="{'not-allowed': !registrationForm.valid, 'pointer': registrationForm.valid}">Submit</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
